<template>
  <a-drawer
    :title="serviceProviderJson ? '编辑服务商' : '创建服务商'"
    width="600"
    :visible="visible"
    :closable="false"
    :footer-style="{ textAlign: 'right' }"
    @close="onClose"
  >
    <!-- form -->
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 服务商名称 -->
      <a-form-item
        label="服务商名称"
        name="name"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          v-model:value="formState.name"
          placeholder="请输入"
        />
      </a-form-item>
      <!-- AD识别码 -->
      <a-form-item
        label="AD识别码"
        name="adj_id"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          v-model:value="formState.adj_id"
          placeholder="请输入"
        />
      </a-form-item>
      <!-- AD识别码 -->
      <a-form-item
        label="AD短链识别码"
        name="adj_linkid"
        :rules="[{ required: true, message: '请输入' }]"
      >
        <a-input
          v-model:value="formState.adj_linkid"
          placeholder="请输入"
        />
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { reactive, ref, nextTick } from 'vue'
import Loading from '@/components/Loading'
import Pub from '@/utils/public'
import { message } from 'ant-design-vue'
// 引入 API
import { serviceProviderSave } from '@/api/admin'

// emit
const emit = defineEmits(['success'])
// form
const RefForm = ref(null)
// 显示
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 修改对象
let serviceProviderJson = ref(null)

// 表单参数
const formState = ref({
  // 服务商名称
  name: undefined,
  // AD识别码
  adj_id: undefined,
  // AD短链识别码
  adj_linkid: undefined
})

// 显示弹窗
function showDrawer(record) {
  visible.value = true
  serviceProviderJson.value = record
  
  // 如果有记录数据，则为编辑模式，填充表单
  if (record && record.id) {
    nextTick(() => {
      formState.value = {
        name: record.name,
        adj_id: record.adj_id,
        adj_linkid: record.adj_linkid
      }
    })
  } else {
    // 新建模式，重置表单
    nextTick(() => {
      formState.value = {
        name: undefined,
        adj_id: undefined,
        adj_linkid: undefined
      }
    })
  }
}

// 关闭弹窗
function onClose() {
  visible.value = false
  // 重置表单
  RefForm.value?.resetFields()
  formState.value = {
    name: undefined,
    adj_id: undefined,
    adj_linkid: undefined
  }
  serviceProviderJson.value = null
}

// 提交
function touchSubmit() {
  RefForm.value.validate().then((res) => {
    // 上传数据
    const params = {
      id: serviceProviderJson.value && serviceProviderJson.value.id,
      ...res,
    }
    isLoading.value = true
    // TODO: 替换为实际的API调用
    serviceProviderSave(params).then((res) => {
      isLoading.value = false
      if (res.code === 0) {
        message.success('保存成功')
        onClose()
        emit('success')
      } else {
        message.error(res.message)
      }
    }).catch(() => {
      isLoading.value = false
      message.error('保存失败')
    })
  }).catch((err) => {
    console.log(err)
  })
}

// 暴露方法给父组件
defineExpose({
  showDrawer
})
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>
